module.exports = __webpack_public_path__ + "assets/img/db71aa1a23fd08a09507c08144dba350.png";